import { InputAdornment, TextFieldProps, TextField, Tooltip } from "@mui/material";
import { FunctionComponent } from "react";
import SearchIcon from '@mui/icons-material/Search';


const SearchInput: FunctionComponent<TextFieldProps> = (props) => {
  return (<>
    <Tooltip sx={{ transform: 'scale(3)' }} title={props?.placeholder || props?.title || 'Pesquise'}>
      <TextField
        size="small"
        sx={{
          ".MuiInputBase-root": {
            bgcolor: '#fff'
          }
        }}
        {...props}
        InputProps={
          {
            startAdornment:
              <InputAdornment position="start" >
                <SearchIcon />
              </InputAdornment >
          }
        }
      />
    </Tooltip>
  </>);
}

export default SearchInput;
